import { render, staticRenderFns } from "./flowCustomerInformation.vue?vue&type=template&id=8d1faed0&scoped=true&"
import script from "./flowCustomerInformation.vue?vue&type=script&lang=js&"
export * from "./flowCustomerInformation.vue?vue&type=script&lang=js&"
import style0 from "./flowCustomerInformation.vue?vue&type=style&index=0&id=8d1faed0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1faed0",
  null
  
)

export default component.exports